import { useStore } from '@/store';

export const isStaffOrServiceProvider = () => {
  return useStore.isStaff() || useStore.isServiceProviderUser();
};

//Get schema name from route or null
export const getRouteSchemaName = (route) => {
  return isStaffOrServiceProvider() ? (route.query.client || route.query.schemaName) : null;
};

// Validate schema context and set errors if invalid
export const validateSchemaAccess = (route, errorMessage = "Organization schema is required!") => {
  const schemaName = route.query.client || route.query.schemaName;

  if (isStaffOrServiceProvider() && !schemaName) {
    return {
      valid: false,
      error: errorMessage,
      errorCode: "Missing Schema"
    };
  }
  return {
    valid: true,
    schemaName: schemaName || null
  };
};